import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material";

import { RestApiService } from "../shared/restApiServices/restapi.service";
import { PlanService } from "../shared/services/planService";

@Component({
  selector: 'app-change-plan-modal',
  templateUrl: './change-plan-modal.component.html',
  styleUrls: ['./change-plan-modal.component.css']
})
export class ChangePlanModalComponent implements OnInit {

  plansOptions:any[]=[];
  selectedPlan:any = {};
  showLoader:boolean;
  confirmUpgrade = false;
  currentPlan:any = {};
  
  constructor(public dialogRef:MatDialogRef<ChangePlanModalComponent> ,private restApiService: RestApiService, private planService:PlanService, private router:Router) {

    this.restApiService.getAllPlansData().subscribe(res=>{
      if(res && res.success == true){
        this.plansOptions = res.data;
        if(this.planService.getPlan())
        {
          this.selectedPlan = this.planService.getPlan();
          this.currentPlan = this.planService.getPlan();
        }
        else
        {
          this.selectedPlan = this.plansOptions[0];
          this.currentPlan = this.plansOptions[0];
        }
      }
      else{
         console.log('No Plans data available');
      }
    })

   }

  ngOnInit() {
  }


  selectPlan(plan){
    this.selectedPlan = plan;
  }

  date = new Date().toLocaleDateString() + " " +new Date().toLocaleTimeString();
  selectedSubInfo="";
  showUpgrade = false;

  showUpgradeDetails(){
    this.showUpgrade = true;
    this.selectedPlan.subscription_info.forEach(data=>{
      this.selectedSubInfo = data + " , " + this.selectedSubInfo;
    })
  }
  onProceed(){
    this.showLoader = true;
    this.planService.setPlan(this.selectedPlan);
    var superAdminID = localStorage.getItem("superAdminID");
    var planID = this.planService.getPlan();
    this.restApiService.changePlan(superAdminID, planID).subscribe(res=>{
      this.showLoader = false;
      if(res && res.success == true) {
        if(res.freePlan)
        {
          this.dialogRef.close();
          this.router.navigateByUrl('/questionnaires');
        }
        else {
          this.planService.setSubscription(res["sub_ID"]);
          this.planService.setOldSubscription(res["subscription_id"]);
          const result = {checkout:true}
          this.dialogRef.close(result);
          // this.router.navigateByUrl('/checkout');
        }
      }
      else {
        console.log(res);
      }
    });
  }

  onClose(){
    this.dialogRef.close(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/change-plan-modal/change-plan-modal.component.ts